import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {Grid, Row, Col} from 'react-bootstrap'
import ContactBox from '../Common/ContactBox/ContactBox'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'
import {connect} from 'react-redux'

import './Layout/Page.css'

class PageScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: {},
      isLoading: true,
      showNotFound: false
    }
  }

  componentWillMount () {
    if (this.props.page) {
      if (this.props.page.key !== this.props.params.key) { return Actions.page(this.props.params.key) }
      return this.setState({data: this.props.page, isLoading: false})
    }
    this.setState({isLoading: true, showNotFound: false})
    Actions.page(this.props.params.key)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.page) {
      if (nextProps.page.key !== nextProps.params.key) { return Actions.page(nextProps.params.key) }
      return this.setState({data: nextProps.page, isLoading: false})
    }
    this.setState({isLoading: true, showNotFound: false})
    Actions.page(nextProps.params.key).then(data => {
      this.setState({isLoading: true}, () => this.setState({data: data, isLoading: false}))
    }).catch((error) => {
      this.setState({isLoading: false})
      if (error.response.status === 404) {
        this.setState({showNotFound: true})
      }
    })
  }

  render () {
    const { data, isLoading, showNotFound } = this.state
    return (
      <div id="page-screen">
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Row>
                <Col sm={10} smOffset={1} xs={12} xsOffset={0}>
                  <Row className="title">
                    <Col xs={12}>
                      <h2>{data.title}</h2>
                    </Col>
                  </Row>
                  <Row className="wrapper">
                    <Col xs={12} className="context" dangerouslySetInnerHTML={{__html: data.context}} />

                    <div className="clearfix" />
                    {this.props.params.key === 'about' && <Col xs={12}>
                      <ContactBox />
                    </Col>}

                    {(data.update !== null) && (<Col xs={12} className="update">
                      به روز شده در <strong>{data.update}</strong>
                    </Col>)}
                  </Row>
                </Col>
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

PageScreen.fetchData = ({params}) => {
  return Actions.page(params.key)
}

function mapStateToProps (state) {
  return {
    page: state.page.currentPage
  }
}

export default connect(mapStateToProps)(PageScreen)



// WEBPACK FOOTER //
// ./src/components/Page/PageScreen.js